import { AxiosInstance } from 'axios'
import { RESULT } from 'constants/Servers'

type Response = {
  type: RESULT
  error?: Error
  data?: any
}

/**
 * サーバーに通信する
 */
 const Connect = {
  get: (instance: AxiosInstance, url: string, params: object) => {
    return instance.request({ method: 'get', url, params })
      .then<Response>((response: any) => {
        if (response.data.message) {
          return { type: RESULT.Error, error: new Error(response.data.message) }
        }
        return { type: RESULT.Success, data: response.data }
      })
      .catch<Response>(() => {
        return { type: RESULT.Error, error: new Error(RESULT.Error) }
      })
  },
  post: (instance: AxiosInstance, url: string, data: object) => {
    return instance.request({ method: 'post', url, data })
      .then<Response>((response: any) => {
        if (response.data.message) {
          return { type: RESULT.Error, error: new Error(response.data.message) }
        }
        return { type: RESULT.Success, data: response.data }
      })
      .catch<Response>(() => {
        return { type: RESULT.Error, error: new Error(RESULT.Error) }
      })
  },
  put: (instance: AxiosInstance, url: string, data: object) => {
    return instance.request({ method: 'put', url, data })
      .then<Response>((response: any) => {
        if (response.data.message) {
          return { type: RESULT.Error, error: new Error(response.data.message) }
        }
        return { type: RESULT.Success, data: response.data }
      })
      .catch<Response>(() => {
        return { type: RESULT.Error, error: new Error(RESULT.Error) }
      })
  },
  delete: (instance: AxiosInstance, url: string, data: object) => {
    return instance.request({ method: 'delete', url, data })
      .then<Response>((response: any) => {
        if (response.data.message) {
          return { type: RESULT.Error, error: new Error(response.data.message) }
        }
        return { type: RESULT.Success, data: response.data }
      })
      .catch<Response>(() => {
        return { type: RESULT.Error, error: new Error(RESULT.Error) }
      })
  }
}

export default Connect